export default __webpack_public_path__ + "static/media/Home-Assist-Logo-No-Icons.a9aabfa5.svg";